// extracted by mini-css-extract-plugin
module.exports = {"link":"confirmEmail_link__3itHR"};